import React, { FunctionComponent } from 'react'

import { Grid, SvgIconProps } from '@material-ui/core'
import { colors } from 'shared/styles/colors'

import { LabelCard, Title, Subtitle } from './styles'

export interface ILabelValueProps {
  title: string
  subtitle1: string
  subtitle2?: string
  icon?: React.ComponentType<SvgIconProps>
}

const LabelValue: FunctionComponent<ILabelValueProps> = ({
  title,
  subtitle1,
  subtitle2,
  icon: IconValue,
}) => {
  const iconType = () => {
    if (IconValue) {
      return (
        IconValue && (
          <IconValue style={{ width: 16, height: 16, color: colors.blue }} />
        )
      )
    }

    return <></>
  }

  const getSubtitle = () => {
    if (subtitle2) {
      return (
        <Grid container>
          <Grid>
            <Subtitle>{subtitle1}</Subtitle>
            {iconType()}
            <Subtitle>{subtitle2}</Subtitle>
          </Grid>
        </Grid>
      )
    }
    return (
      <Grid container>
        <Grid item style={{ paddingRight: 5 }}>
          {iconType()}
        </Grid>
        <Grid>
          <Subtitle>{subtitle1}</Subtitle>
        </Grid>
      </Grid>
    )
  }

  return (
    <LabelCard>
      <Grid container>
        <Title>{title}</Title>
        {getSubtitle()}
      </Grid>
    </LabelCard>
  )
}

export default LabelValue
